import React from 'react';

export const MCSAQuestionnaire = () => {
    return (
        <iframe
            title="Questionnaire"
            src="/mcsa_htmls__TBD/questionnaire.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
